import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { BrandingService } from '@/services/branding.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(async () => {
  // O branding agora é carregado no main.ts antes do mount para evitar flicker
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})